import {$dom} from '../../helpers/dom';
import variables from '../../variables';
import Model from './Model';
import CarouselController from './CarouselCreator';
import tabs from '../components/tabs';
import {loop, warn} from '../../helpers/_utilities';
import {$data} from '../../helpers/data';
import is from 'is_js';
import {$events} from '../../helpers/events';
import smoothScrollbar from '../components/scrollbar';
import phoneMask from '../components/phoneMask';
import cardFees from '../components/cardFees';
import ranges from '../components/range';
import dropdown from '../components/dropdown';
import datepicker from '../components/datepicker';
import pageSwitch from '../components/pageSwitch';
import defaultTooltip from '../components/defaultTooltip';
import mobileMenu from '../components/mobileMenu';
import createChoices from '../components/choices';
import ModalController from '../../ui/Modal';
import {uploadFiles} from '../components/uploadFiles';
import {formValidation} from '../components/formValidation';
import articleSearch from '../components/articleSearchForm';
import scrollTo from '../components/scrollTo';

const {merge} = $data;
const {
	addClass,
	removeClass
} = $dom;

export default class Page extends Model {

	constructor(options = {}) {

		super(options);

		this.exist = true;

		if (is.not.domNode(this.rootElement)) {
			if (this.options.debug) {
				warn(`Instance Page with name "${this.name}" has no root element provided`, 'Page-class')
			}
			this.exist = false;
			return;
		}

		this.defaults = {
			resizeDependentMethods: [],
			modalOverlap: true
		};

		this.options = merge(this.defaults, options);
		this.carousels = this.options.carousels || [];

		this.CarouselController = new CarouselController();

		this.smoothScrollbar = smoothScrollbar();
		this.tabs = tabs();
		this.phoneMask = phoneMask();
		this.cardsFees = cardFees();
		this.ranges = ranges();
		this.dropdown = dropdown();
		this.calendars = datepicker();
		this.pageSwitcher = pageSwitch();
		this.tooltipTitle = defaultTooltip();
		this.mobileMenu = mobileMenu();
		this.choices = createChoices();
		this.modalController = new ModalController({
			overlap: this.options.modalOverlap
		});
		this.filesUpload = uploadFiles();
		this.formValidation = formValidation();
		this.articleSearch = articleSearch();
		this.scrollTo = scrollTo();

		this.methods = [
			this.smoothScrollbar,
			this.tabs,
			this.phoneMask,
			this.cardsFees,
			this.ranges,
			this.dropdown,
			this.calendars,
			this.pageSwitcher,
			this.tooltipTitle,
			this.mobileMenu,
			this.choices,
			this.filesUpload,
			this.formValidation,
			this.articleSearch,
			this.scrollTo
		];

	}
	processMethods(action, methods = this.methods) {
		loop(methods, method => {
			if (
				is.object(method)
				&&
				method.hasOwnProperty(action)
				&&
				is.function(method[action])
			) {
				method[action]();
			}
		});
	}

	resizeDependentMethods(action) {
		let methods = [];

		loop(this.options.resizeDependentMethods, method => {

			method = method.bind(this);

			methods.push(method);

			switch (action) {
				case 'add':
					method.call(this);
					$events.resize('on', method);
					break;

				case 'remove':
					$events.resize('off', method);
					break;
			}
		});

		return methods;
	}

	pageBlurAdd() {
		addClass(variables.dom.mainWrapper, 'is-blurred')
	}

	pageBlurRemove() {
		removeClass(variables.dom.mainWrapper, 'is-blurred')
	}

	listeners(action) {
		switch (action) {
			case 'add':

				$events.delegate
					.on(variables.customEventNames.modal.open, '.modal', this.pageBlurAdd)
					.on(variables.customEventNames.modal.close, '.modal', this.pageBlurRemove)
				;

				break;
			case 'remove':
				$events.delegate
					.off(variables.customEventNames.modal.open, '.modal', this.pageBlurAdd)
					.off(variables.customEventNames.modal.close, '.modal', this.pageBlurRemove)
				;
				break;
		}
	}

	init() {
		this.listeners('add');
		this.processMethods('init');
		this.CarouselController.create(this.carousels);
		this.modalController.init();
		this.resizeDependentMethods('add');

		super.init(this);
		return this;
	}

	destroy() {
		this.listeners('remove');
		this.processMethods('destroy');
		this.CarouselController.destroy();
		this.modalController.destroy();
		this.resizeDependentMethods('remove');

		super.destroy(this);
		return this;
	}
}
